// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Renders a list of shape icons to choose from.
 */
M.View.ProductDetails.ShapePicker = Backbone.View.extend({
  tagName: 'ul',
  className: 'shapePicker',
  template: M.Template.ProductDetail.ShapePicker,

  events: {
    'click .shapeOption': 'shapeOptionClick'
  },

  initialize: function() {
    if (!this.collection) {
      M.required(this.options.shapeOptionsJson);
      this.collection = new M.Collection.ProductDetails.Shapes(
        this.options.shapeOptionsJson);
    }
  },

  render: function() {
    this.$el = $(this.el);
    this.$el.empty();

    var templateVariables = {
      shapes: this.collection.models
    };
    this.$el.html(this.template(templateVariables));

    // Default to the flat card option (no die cut)
    this.selectFirst();

    this.selectShape(this.options.selectedDieCutCode);

    // Default to the flat card option (no die cut)
    if (this.collection.getSelected() === null) {
      this.selectFirst();
    }

    return this;
  },

  /**
   * Select the first option. (without triggering a click event)
   */
  selectFirst: function() {
    this.deSelect();
    $(this.$el.find('.shapeOption')[0]).addClass('active');
    this.collection.select(this.collection.models[0]);
  },

  selectShape: function(dieCutCode) {
    if (typeof dieCutCode === 'undefined' ||
      dieCutCode === null || dieCutCode === '') {
      return;
    }

    var that = this;

    this.deSelect();

    var shapeOptions = $(this.$el.find('.shapeOption'));
    for (var i = 0; i < shapeOptions.length; i++) {
      if ($(shapeOptions[i]).data('code') === dieCutCode) {
        $(shapeOptions[i]).addClass('active');
      }
    }

    _.each(this.collection.models, function(model) {
      if (model.get('code') === dieCutCode) {
        that.collection.select(model);
      }
    });
  },

  /**
   * Deselect any selected options.
   */
  deSelect: function() {
    this.$el.find('.shapeOption').removeClass('active');
    this.collection.select(null);
  },

  shapeOptionClick: function(e) {
    var previousShape = this.collection.getSelected();
    this.$el.find('.shapeOption').removeClass('active');
    var clickedElement = $(e.currentTarget);
    clickedElement.addClass('active');
    var selectedModel = this.collection.get(clickedElement.data('id'));
    this.collection.select(selectedModel);
    this.trigger('shape_option_clicked', previousShape);
  }
});
